export const CONTRACT_ADDRESS = "0xeB3Ba25400A4d716d091090942705aD51d04B7ea";
export const PARENT_CONTRACT_ABI = [
  {
    inputs: [
      { internalType: "address", name: "notaryAddress", type: "address" },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  { inputs: [], name: "DuplicateProof", type: "error" },
  { inputs: [], name: "InvalidDigest", type: "error" },
  { inputs: [], name: "InvalidNotary", type: "error" },
  { inputs: [], name: "InvalidSignature", type: "error" },
  { inputs: [], name: "InvalidSignatureLength", type: "error" },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "OwnableInvalidOwner",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "OwnableUnauthorizedAccount",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      { internalType: "address", name: "notaryAddress", type: "address" },
    ],
    name: "addNotary",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    name: "digests",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "isNotary",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "notaryAddress", type: "address" },
    ],
    name: "removeNotary",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "digest", type: "bytes32" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" },
      { internalType: "address", name: "signer", type: "address" },
      { internalType: "bytes32", name: "manifest", type: "bytes32" },
      { internalType: "bytes32", name: "value", type: "bytes32" },
    ],
    name: "verifyNotarySignature",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export const CONTRACT_ABI = [
  {
    inputs: [
      { internalType: "address", name: "notaryAddress", type: "address" },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "sessionHash", type: "bytes32" },
      { internalType: "bytes32", name: "scriptHash", type: "bytes32" },
    ],
    name: "calculateDigest",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string", name: "version", type: "string" },
      { internalType: "string", name: "scriptRaw", type: "string" },
    ],
    name: "calculateScriptHash",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string", name: "version", type: "string" },
      { internalType: "string", name: "issuedAt", type: "string" },
      { internalType: "string", name: "nonce", type: "string" },
      { internalType: "string", name: "sessionId", type: "string" },
      {
        components: [
          { internalType: "string", name: "key", type: "string" },
          { internalType: "string", name: "value", type: "string" },
        ],
        internalType: "struct PlutoAttestationVerifier.ProofData[]",
        name: "data",
        type: "tuple[]",
      },
    ],
    name: "calculateSessionHash",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "string[]", name: "values", type: "string[]" },
    ],
    name: "createProofDataArray",
    outputs: [
      {
        components: [
          { internalType: "string", name: "key", type: "string" },
          { internalType: "string", name: "value", type: "string" },
        ],
        internalType: "struct PlutoAttestationVerifier.ProofData[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "string", name: "version", type: "string" },
          { internalType: "string", name: "scriptRaw", type: "string" },
          { internalType: "string", name: "issuedAt", type: "string" },
          { internalType: "string", name: "nonce", type: "string" },
          { internalType: "string", name: "sessionId", type: "string" },
          {
            components: [
              { internalType: "string", name: "key", type: "string" },
              { internalType: "string", name: "value", type: "string" },
            ],
            internalType: "struct PlutoAttestationVerifier.ProofData[]",
            name: "data",
            type: "tuple[]",
          },
        ],
        internalType: "struct PlutoAttestationVerifier.AttestationInput",
        name: "input",
        type: "tuple",
      },
    ],
    name: "getCalculatedHashes",
    outputs: [
      { internalType: "bytes32", name: "scriptHash", type: "bytes32" },
      { internalType: "bytes32", name: "sessionHash", type: "bytes32" },
      { internalType: "bytes32", name: "digest", type: "bytes32" },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "verifier",
    outputs: [{ internalType: "contract Verifier", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "string", name: "version", type: "string" },
          { internalType: "string", name: "scriptRaw", type: "string" },
          { internalType: "string", name: "issuedAt", type: "string" },
          { internalType: "string", name: "nonce", type: "string" },
          { internalType: "string", name: "sessionId", type: "string" },
          {
            components: [
              { internalType: "string", name: "key", type: "string" },
              { internalType: "string", name: "value", type: "string" },
            ],
            internalType: "struct PlutoAttestationVerifier.ProofData[]",
            name: "data",
            type: "tuple[]",
          },
        ],
        internalType: "struct PlutoAttestationVerifier.AttestationInput",
        name: "input",
        type: "tuple",
      },
      {
        components: [
          { internalType: "bytes32", name: "digest", type: "bytes32" },
          { internalType: "uint8", name: "v", type: "uint8" },
          { internalType: "bytes32", name: "r", type: "bytes32" },
          { internalType: "bytes32", name: "s", type: "bytes32" },
          { internalType: "address", name: "expectedSigner", type: "address" },
        ],
        internalType: "struct PlutoAttestationVerifier.AttestationSignature",
        name: "signature",
        type: "tuple",
      },
    ],
    name: "verifyAttestation",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "string", name: "version", type: "string" },
          { internalType: "string", name: "scriptRaw", type: "string" },
          { internalType: "string", name: "issuedAt", type: "string" },
          { internalType: "string", name: "nonce", type: "string" },
          { internalType: "string", name: "sessionId", type: "string" },
          {
            components: [
              { internalType: "string", name: "key", type: "string" },
              { internalType: "string", name: "value", type: "string" },
            ],
            internalType: "struct PlutoAttestationVerifier.ProofData[]",
            name: "data",
            type: "tuple[]",
          },
        ],
        internalType: "struct PlutoAttestationVerifier.AttestationInput[]",
        name: "inputs",
        type: "tuple[]",
      },
      {
        components: [
          { internalType: "bytes32", name: "digest", type: "bytes32" },
          { internalType: "uint8", name: "v", type: "uint8" },
          { internalType: "bytes32", name: "r", type: "bytes32" },
          { internalType: "bytes32", name: "s", type: "bytes32" },
          { internalType: "address", name: "expectedSigner", type: "address" },
        ],
        internalType: "struct PlutoAttestationVerifier.AttestationSignature[]",
        name: "signatures",
        type: "tuple[]",
      },
    ],
    name: "verifyMultipleAttestations",
    outputs: [{ internalType: "bool[]", name: "", type: "bool[]" }],
    stateMutability: "nonpayable",
    type: "function",
  },
];
